"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Clickable_1 = require("./Clickable");
const Icon_1 = require("./Icon");
const Text_1 = require("./Text");
const constants_1 = require("../constants");
const StyledClickable = (0, styled_1.default)(Clickable_1.Clickable)(({ selected, disabled }) => ({
    border: constants_1.theme.border.style.thin,
    borderRadius: constants_1.theme.border.radius.normal,
    boxShadow: constants_1.theme.boxShadow.normal,
    position: 'relative',
    borderColor: selected ? constants_1.Color.BLUE : constants_1.Color.MEDIUM_GREY,
    backgroundColor: selected ? constants_1.Color.LIGHTEST_BLUE : constants_1.Color.WHITE,
    padding: constants_1.theme.spacing[3],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 120,
    justifyContent: 'center',
    gap: constants_1.theme.spacing[1],
    ...(disabled
        ? { cursor: 'not-allowed' }
        : { ':hover': { backgroundColor: constants_1.Color.LIGHTEST_BLUE } }),
}));
const SelectableCard = ({ icon, label, selected, onClick, disabled, }) => {
    return ((0, jsx_runtime_1.jsxs)(StyledClickable, { selected: selected, onClick: disabled ? undefined : onClick, disabled: disabled, children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { styles: {
                    position: 'absolute',
                    top: constants_1.theme.spacing[2],
                    left: constants_1.theme.spacing[2],
                }, name: selected ? 'CheckCircleIcon' : 'Circle', size: "md", design: selected ? 'solid' : 'outline', color: selected ? constants_1.Color.BLUE : constants_1.Color.MEDIUM_GREY }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: constants_1.Color.BLUE, name: icon, size: "lg" }), (0, jsx_runtime_1.jsx)(Text_1.Text, { textAlign: "center", color: selected ? constants_1.Color.BLUE : constants_1.Color.DARKER_GREY, children: label })] }));
};
exports.SelectableCard = SelectableCard;
